import { fetch } from '../utils/fetch'
import {
  ENDPOINT_LIBRARIES,
  ENDPOINT_LIBRARY,
  ENDPOINT_NEW_LIBRARY
} from '../constants'

const LIBRARIES_REQUEST = 'blayzr/libraries/REQUEST'
const LIBRARIES_SUCCESS = 'blayzr/libraries/SUCCESS'
const LIBRARIES_FAILURE = 'blayzr/libraries/FAIL'

const SAVE_LIBRARY_REQUEST = 'blayzr/libraries/SAVE_REQUEST'
const SAVE_LIBRARY_SUCCESS = 'blayzr/libraries/SAVE_SUCCESS'
const SAVE_LIBRARY_FAILURE = 'blayzr/libraries/SAVE_FAIL'

const DELETE_LIBRARY = 'blayzr/libraries/DELETE'

const initialState = {
  data: null,
  fetching: false,
  error: null,
  submitting: false,
  submitError: null
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case LIBRARIES_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case LIBRARIES_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload
      }
    case LIBRARIES_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case SAVE_LIBRARY_REQUEST:
      return {
        ...state,
        submitting: true,
        submitError: false
      }
    case SAVE_LIBRARY_SUCCESS:
      return {
        ...state,
        submitting: false,
        data: state.data.map(library => {
          return library.id === meta.id ? { ...library, ...payload } : library
        }).concat(meta.id ? [] : payload)
      }
    case SAVE_LIBRARY_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: payload
      }
    case DELETE_LIBRARY:
      if (state.data) {
        return {
          ...state,
          data: state.data.filter(library => library.id !== meta.id)
        }
      }
      return state
    default:
      return state
  }
}

export function librariesRequest () {
  return {
    type: LIBRARIES_REQUEST
  }
}

export function librariesSuccess (data) {
  return {
    type: LIBRARIES_SUCCESS,
    payload: data
  }
}

export function librariesFailure (error) {
  return {
    type: LIBRARIES_FAILURE,
    payload: { error }
  }
}

export function saveLibraryRequest (data, id) {
  return {
    type: SAVE_LIBRARY_REQUEST,
    payload: data,
    meta: { id }
  }
}

export function saveLibrarySuccess (data, id) {
  return {
    type: SAVE_LIBRARY_SUCCESS,
    payload: data,
    meta: { id }
  }
}

export function saveLibraryFailure (error) {
  return {
    type: SAVE_LIBRARY_FAILURE,
    payload: error
  }
}

export function fetchLibraries () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token
    }
    dispatch(librariesRequest())
    return fetch(ENDPOINT_LIBRARIES, options, dispatch).then(data => {
      dispatch(librariesSuccess(data.records))
      return data.records
    }, e => {
      dispatch(librariesFailure(e))
    })
  }
}

export function saveLibrary (data, id) {
  return (dispatch, getState) => {
    const endpoint = id ? ENDPOINT_LIBRARY.replace(':id', id) : ENDPOINT_NEW_LIBRARY
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: { ...data, id }
    }
    dispatch(saveLibraryRequest(data, id))
    return fetch(endpoint, options, dispatch).then(data => {
      dispatch(saveLibrarySuccess(data.records, id))
    }, e => {
      dispatch(saveLibraryFailure(e))
    })
  }
}

export function deleteLibrary (id) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_LIBRARY.replace(':id', id)
    fetch(endpoint, {
      method: 'delete',
      token: getState().auth.token
    })
    dispatch({
      type: DELETE_LIBRARY,
      meta: { id }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/libraries.js